import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { academylist, workercount } from "../../../services/admin";
import Select from "react-select";

export default function Workersdashboard() {
  const [filter, setFilter] = useState([]);
  const [wlist, setWList] = useState([]);
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const columnDefs = [
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Workers Name",
      field: "worker_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Employee ID",
      field: "employee_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      field: "type_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "active",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: (params) => {
        if (params.value === "Active") {
          return { color: "green", fontWeight: "bold" };
        } else {
          return { color: "red", fontWeight: "bold" };
        }
      }
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);

              }
            }

          }
        }
      });
    } else {
      listall("");
    }
  }, []);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e)
    } else {
      setAcaID("");
      listall("");
    }
  }

  function listall(aid) {
    setFilter([]);
    setWList([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    workercount(temp).then((res) => {
      if (res.status === true) {
        setFilter(res.data.counts);
        setWList(res.data.details);
      }
    });

  }

  const cardColors = ['', 'lkg', 'I-st', 'II-st'];
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Workers Dashboard</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Workers</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Workers Dashboard
          </li>
        </ol>
      </div>
      <div className="row row-sm">
        {localStorage.getItem("Role") === "1" && (
          <div className="col-xl-6 col-sm-6">
            <div className="mb-3">
              <label className="form-label">
                Select Academy
                <span className="text-danger"> *</span>
              </label>
              <Select
                className="default-select"
                placeholder="Select Academy"
                value={acaid}
                options={alist}
                onChange={handleAcademy}
                isSearchable={true}
                isClearable
                hidden
              />

            </div>
          </div>
        )}
      </div>

      <div className="row row-sm">
        {filter.map((item, index) => {
          const cardColorClass = cardColors[index % 4];
          return (
            <div className="col-xl-3 col-md-3" key={index}>
              <div className="card custom-card">
                <div className={`card-bodyy ${cardColorClass}`}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="product-content">
                        <h3 className="title">
                          <a>{item.type_name}</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                  <div className="col-md-4 col text-center float-end">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{item.active}</a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted">Present</p>
                    </div>
                  </div>
                  <div className="col-md-4 col text-center float-end">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{item.left}</a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted">Left</p>
                    </div>
                  </div>
                  <div className="col-md-4 col text-center float-end">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{item.total}</a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted">Total</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })

        }


      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="card-header border-bottom-0 pt-0 ps-0 pe-0 d-flex">
                <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                All Workers
                 </h2>
                  {/* <label className="main-content-label mb-2">
                    {" "}
                    All Workers
                  </label>{" "} */}
                </div>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={wlist}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
